import * as RadioGroup from './Component.tsx';
import { Component, JSXElement, mergeProps, splitProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';

type RadioOptions<T extends Record<string, any> = {}> = {
  value: string;
  label: JSXElement;
  disabled?: boolean;
  onClick?: (e: Event) => void;
  testId: string;
  wrapperComponent?: Component<{ children: JSXElement } & T>;
  class?: string;
  controlClass?: string;
  inline?: boolean;
};

type RadioProps = RadioGroup.RootProps & {
  options: RadioOptions[];
  hideRadioControl?: boolean;
};

export const Radio = (props: RadioProps) => {
  const merged = mergeProps({}, props);

  const [componentProps, arkProps] = splitProps(merged, [
    'options',
    'hideRadioControl'
  ]);

  const orientation = arkProps.orientation || 'vertical';

  return (
    <RadioGroup.Root {...(arkProps as RadioGroup.RootProps)}>
      <div
        class={`flex gap-3 flex-wrap`}
        classList={{
          'flex-col': orientation === 'vertical'
        }}
      >
        {componentProps.options.map((option) => {
          const Wrapper: Component<{ children: JSXElement }> =
            option.wrapperComponent ||
            ((props: { children: JSXElement }) => <>{props.children}</>);
          return (
            <Wrapper>
              <RadioGroup.Item
                value={option.value}
                disabled={option.disabled}
                class={twMerge(
                  `flex-wrap items-start max-w-full px-6 py-3 border rounded-l1 data-[state=unchecked]:hover:!bg-bg-subtle
      data-[state=checked]:bg-bg-muted data-[state=checked]:border-fg-default
      data-[state=unchecked]:bg-bg-default data-[state=unchecked]:border-border-muted`,
                  option.class ?? ''
                )}
                classList={{
                  'gap-0': !!componentProps.hideRadioControl
                }}
                onClick={(e) => option.onClick && option.onClick(e)}
                data-testid={option.testId}
              >
                <RadioGroup.ItemControl
                  class={twMerge(
                    `flex-none mt-[3px] w-4 h-4 min-w-4 min-h-4`,
                    option.controlClass
                  )}
                  classList={{
                    'w-0 h-0 opacity-0': !!componentProps.hideRadioControl
                  }}
                />
                <RadioGroup.ItemText
                  class={`data-[state=unchecked]:text-fg-muted flex-1 min-w-0 break-words`}
                >
                  {option.label}
                </RadioGroup.ItemText>
                <RadioGroup.ItemHiddenInput />
              </RadioGroup.Item>
            </Wrapper>
          );
        })}
      </div>
    </RadioGroup.Root>
  );
};
